export const SALARIED_CARD_DATA = [
  {
    priceRange: '5-10',
    badge: {
      exist: false,
      value: '',
    },
    planType: 'ITR 1 or 4',
  },
  {
    priceRange: '10-20',
    badge: {
      exist: true,
      value: 'GOLD',
    },
    planType: 'ITR 1 or 4',
  },
  {
    priceRange: 'Above 20',
    badge: {
      exist: true,
      value: 'PLATINUM',
    },
    planType: 'ITR 1 or 4',
  },
];

export const CAPITAL_GAIN_CARD_DATA = [
  {
    priceRange: '5-20',
    badge: {
      exist: false,
      value: '',
    },
    planType: 'ITR 2 or 3',
  },
  {
    priceRange: 'Above 20',
    badge: {
      exist: true,
      value: 'PLATINUM',
    },
    planType: 'ITR 2 or 3',
  },
];

export const NRI_INCOME = [
  {
    priceRange: '< 5',
    badge: {
      exist: false,
      value: '',
    },
    planType: 'ITR 2 or 3',
  },
  {
    priceRange: 'Above 5 Lakhs',
    badge: {
      exist: false,
      value: '',
    },
    planType: 'ITR 2 or 3',
  },
];

export const SHOW_ICON: Record<string, boolean> = {
  prod_self_itr_5: false,
  prod_self_itr_1: true,
  prod_self_itr_8: false,
  prod_self_itr_2: true,
  prod_self_itr_3: false,
  prod_self_itr_6: true,
};

export const CARD_COLOR_VALUE = {
  GOLD: 'linear-gradient(135deg, #FBD039 0%, #FDDB85 38.02%, #FBB939 81.77%)',
  PLATINUM:
    'linear-gradient(137deg, #ACC1E2 0%, #E7EDFC 41.67%, #B0C0D7 94.27%)',
};
